import { Host, h } from "@stencil/core";
import { getFormConstraints } from "../../utils/FormDefinition";
export class ApieFormListDefinition {
    constructor() {
        this.instantiated = false;
        this.name = undefined;
        this.label = null;
        this.definitionId = undefined;
        this.prototyped = false;
        this.status = 'idle';
        this.valueWhenMissing = [];
    }
    connectedCallback() {
        this.instantiated = true;
    }
    disconnectedCallback() {
        this.instantiated = false;
    }
    async getDefinition() {
        const newValue = this.definitionId;
        this.status = 'retrieving child metadata';
        const definition = await new Promise((resolve, reject) => {
            const id = setInterval(() => {
                if (!this.instantiated || this.definitionId !== newValue) {
                    clearInterval(id);
                    reject(new Error('definitionId changed or component destroyed'));
                }
                const definition = document.getElementById(this.definitionId);
                if (definition) {
                    clearInterval(id);
                    resolve(definition);
                }
            });
        });
        this.status = 'building';
        const constraints = await getFormConstraints(this.el);
        const subformDefinition = await definition.getDefinition();
        this.status = 'built';
        return Promise.resolve({
            fieldType: 'list',
            name: this.name,
            label: this.label,
            subField: subformDefinition,
            unique: false,
            valueWhenMissing: this.valueWhenMissing,
            types: ['group'],
            constraints,
        });
    }
    render() {
        return (h(Host, { key: '38e2096edb6ce145dc0fd2b1f09d482227ebd34e' }, h("slot", { key: 'b88a121f9f08ff45ee80734cb0c7087e4dda1049' })));
    }
    static get is() { return "apie-form-list-definition"; }
    static get originalStyleUrls() {
        return {
            "$": ["apie-form-list-definition.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["apie-form-list-definition.css"]
        };
    }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "name",
                "reflect": false
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string|null",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "null"
            },
            "definitionId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "definition-id",
                "reflect": false
            },
            "prototyped": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "prototyped",
                "reflect": true,
                "defaultValue": "false"
            },
            "status": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "status",
                "reflect": true,
                "defaultValue": "'idle'"
            },
            "valueWhenMissing": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "value-when-missing",
                "reflect": true,
                "defaultValue": "[]"
            }
        };
    }
    static get methods() {
        return {
            "getDefinition": {
                "complexType": {
                    "signature": "() => Promise<FieldList>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "FieldList": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::FieldList"
                        }
                    },
                    "return": "Promise<FieldList>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=apie-form-list-definition.js.map
